import { Headset } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Reveal, Chapter } from "./Reveal";

const FAQ = [
  {
    q: "Что такое VPN простыми словами?",
    a: "Приложение, которое меняет то, откуда интернет видит вас. Как будто вы заходите в сеть из другой страны — или из своей, если вы сейчас далеко.",
  },
  {
    q: "Это законно?",
    a: "Да, использовать VPN законно. НОРА — обычное приложение для приватности и доступа к своим сервисам.",
  },
  {
    q: "На скольких устройствах можно пользоваться?",
    a: "Достаточно для одного человека и его телефона, ноутбука и планшета одновременно.",
  },
  {
    q: "Можно ли отменить в любой момент?",
    a: "Да, без звонков в поддержку — прямо в настройках подписки.",
  },
  {
    q: "Нужно ли разбираться в настройках?",
    a: "Нет. Установили, нажали кнопку — готово. Все остальное кротик берет на себя.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Chapter n="05">Помощь и вопросы</Chapter>
        <div className="mt-8 grid items-start gap-5 lg:grid-cols-[1fr_1.3fr]">
          <Reveal>
            <div
              data-testid="guarantee-block"
              className="rounded-[2rem] border border-nora-mint/25 bg-nora-mint/10 p-8 sm:p-10"
            >
              <div className="inline-flex rounded-2xl bg-nora-mint p-3.5 text-white">
                <Headset className="h-7 w-7" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight md:text-3xl">
                Не работает — напишите в поддержку
              </h3>
              <p className="mt-3 leading-relaxed text-nora-ink/70 md:text-lg">
                Поможем разобраться. Без бюрократии и лишних вопросов.
              </p>
              <a
                href="/support"
                data-testid="guarantee-support-link"
                className="mt-5 inline-flex items-center gap-1.5 font-semibold text-nora-mint hover:underline"
              >
                Написать в поддержку
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <Accordion
              type="single"
              collapsible
              data-testid="faq-accordion"
              className="rounded-[2rem] border border-nora-ink/5 bg-nora-surface px-6 py-2 shadow-sm sm:px-8"
            >
              {FAQ.map((item, i) => (
                <AccordionItem
                  key={item.q}
                  value={`faq-${i + 1}`}
                  data-testid={`faq-item-${i + 1}`}
                  className="border-nora-ink/10"
                >
                  <AccordionTrigger
                    data-testid={`faq-question-${i + 1}`}
                    className="py-5 font-display text-base font-bold hover:no-underline md:text-lg [&>svg]:text-nora-accent"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="leading-relaxed text-nora-ink/70">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
